import { Api } from '@axiom/ui';
import type { Account, AfcSubmissionsItem } from '@axiom/validation';

import ApiHelper from '../lib/api-helper';
import { EnvUtil } from '../utils/env-util';

const api = new ApiHelper('ACCOUNTS_SUBMISSIONS');
export const getAccountSubmissionsForStore = async (accountId: string) => {
  const { data } = await api.GET(
    `${EnvUtil.apiAltUrl}/accounts/${accountId}/submissions`
  );
  return data;
};

class AccountSubmissionsApiClass extends Api {
  constructor() {
    super({
      domain: EnvUtil.apiAltUrl,
      cookieDomain: EnvUtil.cookieDomain,
    });
  }

  readAccountSubmissions(accountId: Account['id']) {
    return super.read<{ data: AfcSubmissionsItem[] }>({
      endpoint: `/accounts/${accountId}/submissions`,
      method: 'GET',
    });
  }

  async refreshAccountSubmissions(accountId: Account['id']) {
    return super.invalidate(`/accounts/${accountId}/submissions`);
  }
}

export const AccountSubmissionsApi = new AccountSubmissionsApiClass();
